import { render, staticRenderFns } from "./advanced-settings.vue?vue&type=template&id=c84755de&"
import script from "./advanced-settings.vue?vue&type=script&lang=js&"
export * from "./advanced-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports